const lazyLoadOptions = {
  selector: 'img',
  loading: 'https://static.nuonuo.com.cn/zycmp/placeholder.png!/fw/1280',
  error: 'https://static.nuonuo.com.cn/zycmp/placeholder.png!/fw/1280',
}

const globalImagePlaceholder = 'https://static.nuonuo.com.cn/zycmp/placeholder.png!/fw/1920'

export {
  globalImagePlaceholder,
  lazyLoadOptions,
}